exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sdk-contents{padding-top:30px;flex:1}.down-title{font-size:32px;font-family:NanumBarunGothicOTF;font-weight:400}.sdk-down-box{width:80%;height:276px;border-radius:3px;background-color:#fff;box-shadow:0 10px 60px 0 hsla(0,0%,85%,.43);padding:30px;display:flex;flex-direction:column;align-items:center;justify-content:center;margin-top:30px}.sdk-box-tag{height:46px;font-size:40px;font-weight:400}.sdk-box-btn,.sdk-box-tag{font-family:NanumBarunGothicOTF;text-align:center}.sdk-box-btn{width:416px;height:64px;border-radius:3px;box-shadow:0 3px 10px 0 rgba(75,116,255,.6);background-color:#4b74ff;font-size:20px;line-height:64px;color:#fff;cursor:pointer;border:none;margin-top:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c4d6568","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SellerManager/SDKDownload.vue
// module id = 208
// module chunks = 0